module.exports = __webpack_public_path__ + "img/2_12_1.4652b361.jpg";